import { useEffect, useState } from "react";
import { fetchClubMemberDiscount } from "@/lib/api";

let cached = null;

// Standing Club member discount rule (server is the source of truth for the final amount).
export const useMemberDiscountRule = () => {
    const [rule, setRule] = useState(cached);
    useEffect(() => {
        if (cached) return;
        fetchClubMemberDiscount().then((r) => { cached = r; setRule(r); }).catch(() => {});
    }, []);
    return rule;
};

export const computeMemberDiscount = (rule, { member, hasCode, orderType = "collection", subtotal }) => {
    if (!rule?.active || !member || hasCode || !(rule.value > 0) || subtotal < (rule.min_order || 0)) return 0;
    if (rule.collection_only && orderType !== "collection") return 0;
    return rule.type === "percent"
        ? Math.round(subtotal * rule.value) / 100
        : Math.min(rule.value, subtotal);
};

export const memberDiscountLabel = (rule) =>
    rule?.type === "percent" ? `Club member ${rule.value}%` : `Club member £${Number(rule?.value || 0).toFixed(2)} off`;

// Club member discount and a code never stack — the bigger one wins (tie → member, so the code isn't used up).
export const bestDiscount = (memberAmt, codeAmt) =>
    memberAmt > 0 && memberAmt >= codeAmt ? { member: memberAmt, code: 0 } : { member: 0, code: codeAmt };

export const CodeNotUsedNote = ({ code, show }) => !show ? null : (
    <div className="font-mono text-[11px] text-muted" data-testid="code-not-used-note">
        Code {code} not used — your club discount is bigger
    </div>
);
